import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="blogs-page">
            {/* Hero Section */}
            <section className="blogs-hero-section padding-left-right py-5">
                <div className="container-fluid">
                    <div className="row align-items-center" style={{ minHeight: "50vh" }}>
                        <div className="col-12 text-center">
                            <p className="text-uppercase mb-3" style={{
                                color: "#4187f7",
                                fontSize: "0.9rem",
                                fontWeight: "600",
                                letterSpacing: "2px"
                            }}>
                                LATEST INSIGHTS
                            </p>
                            <h1 className="display-3 fw-bold text-white mb-4">
                                Blogs
                            </h1>
                            <p className="lead text-white-50 mx-auto" style={{ maxWidth: "700px" }}>
                                Stay updated with the latest trends, insights, and innovations in technology,
                                AI, development, and digital transformation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="blog-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="services-main-heading">
                            Latest From Our <span className="text-gradient">Blog</span>
                        </h2>

                    </div>

                    <div className="row g-4">
                        {/* Blog 1 - Website Development */}
                        <div className="col-lg-4 col-md-6">
                            <Link to="/blog/website-development" style={{ textDecoration: 'none' }}>
                                <div className="blog-card">
                                    <div className="blog-card-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&q=80"
                                            alt="Website Development"
                                        />
                                        <div className="blog-card-overlay"></div>
                                        <div className="blog-category-badge">Website Development</div>
                                    </div>
                                    <div className="blog-card-content">
                                        <div className="blog-card-meta">
                                            <span className="blog-date">
                                                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                December 1, 2024
                                            </span>
                                        </div>
                                        <h3 className="blog-card-title">
                                            Building Modern Websites: A Complete Guide to Website Development in 2024
                                        </h3>
                                        <p className="blog-card-excerpt">
                                            Discover how professional website development can transform your online presence and drive business growth in today's digital landscape.
                                        </p>
                                        <div className="blog-read-more">
                                            Read More
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        {/* Blog 2 - Digital Marketing */}
                        <div className="col-lg-4 col-md-6">
                            <Link to="/blog/digital-marketing" style={{ textDecoration: 'none' }}>
                                <div className="blog-card">
                                    <div className="blog-card-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                                            alt="Digital Marketing"
                                        />
                                        <div className="blog-card-overlay"></div>
                                        <div className="blog-category-badge">Digital Marketing</div>
                                    </div>
                                    <div className="blog-card-content">
                                        <div className="blog-card-meta">
                                            <span className="blog-date">
                                                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                December 15, 2024
                                            </span>
                                        </div>
                                        <h3 className="blog-card-title">
                                            Digital Marketing Strategies That Drive Real Business Results in 2024
                                        </h3>
                                        <p className="blog-card-excerpt">
                                            Learn how to leverage powerful digital marketing strategies to increase brand visibility, generate leads, and accelerate growth.
                                        </p>
                                        <div className="blog-read-more">
                                            Read More
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        {/* Blog 3 - IT Consulting */}
                        <div className="col-lg-4 col-md-6">
                            <Link to="/blog/it-consulting" style={{ textDecoration: 'none' }}>
                                <div className="blog-card">
                                    <div className="blog-card-image">
                                        <img
                                            src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
                                            alt="IT Consulting"
                                        />
                                        <div className="blog-card-overlay"></div>
                                        <div className="blog-category-badge">IT Consulting</div>
                                    </div>
                                    <div className="blog-card-content">
                                        <div className="blog-card-meta">
                                            <span className="blog-date">
                                                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                December 19, 2024
                                            </span>
                                        </div>
                                        <h3 className="blog-card-title">
                                            IT Consulting: Strategic Technology Solutions for Business Transformation
                                        </h3>
                                        <p className="blog-card-excerpt">
                                            Explore how expert IT consulting can help your business leverage technology for competitive advantage and sustainable growth.
                                        </p>
                                        <div className="blog-read-more">
                                            Read More
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Blogs;
